import releaseOffer from '../../assets/img/OFFERX-FEATURES-01.svg';
import eSign from '../../assets/img/OFFERX-FEATURES-02.svg';
import VerifyImg from '../../assets/img/OFFERX-FEATURES-04.svg';
import easyAccess from '../../assets/img/OFFERX-FEATURES-05.svg';

export const LandingPageCarousels = [
    {
        src: releaseOffer,
        alt: 'Release Offers',
        title: 'The Ultimate Online Platform For Seamless Job Offer Management!',
        content:
            'OfferX is an innovative online platform that empowers employers to streamline their hiring process by releasing job offers through a secure digital portal. With OfferX, candidates can conveniently sign in and swiftly accept the offer, ensuring a smooth and efficient recruitment experience for both employers and job seekers.',
    },
    {
        src: eSign,
        alt: 'E Sign',
        title: 'Seamless And Secure: Empowering Candidates To E-Sign With Confidence.',
        content:
            'OfferX simplifies the acceptance process for candidates by offering a secure and user-friendly e-signature platform. With just a few clicks, candidates can confidently indicate their acceptance online. Our strong encryption ensures the safety of their personal information, eliminating the need for cumbersome paperwork.',
    },
    {
        src: VerifyImg,
        alt: 'Verify',
        title: 'Empowering Swift Compliance Insights For Candidates And Companies.',
        content:
            ' With OfferX, you gain the power to swiftly and effortlessly assess the compliance status of both candidates and companies regarding contract offers. Our platform provides you with a clear and comprehensive view of their history, allowing you to identify instances of adherence or violation with ease.',
    },
    {
        src: easyAccess,
        alt: 'Easy Access',
        title: 'Streamlined Offer Management For Companies and Candidates.',
        content:
            'OfferX offers a user-friendly interface for companies to effortlessly release and track offers, gaining greater control and transparency in the hiring process. Minimize ghosting and improve recruitment efficiency. For candidates, our secure and centralized hub simplifies viewing and responding to offers from various organizations, eliminating email clutter and ensuring data protection. Confidently accept or negotiate offers with OfferX.',
    },
];

export const CarouselButtons = [
    {
        index: 0,
        buttonText: 'Release Offers',
    },
    {
        index: 1,
        buttonText: 'eSign',
    },
    {
        index: 2,
        buttonText: 'Verify',
    },
    {
        index: 3,
        buttonText: 'Easy Access',
    },
];

export const LandingPageCounters = [
    {
        title: 'Employers Served',
        start: 0,
        end: 2500,
    },
    {
        title: 'Candidates in the System',
        start: 0,
        end: 200000,
    },
    {
        title: 'Offers Released',
        start: 0,
        end: 8500,
    },
    {
        title: 'Country Presence',
        start: 0,
        end: 3,
    },
];
